import React, { useEffect } from "react";
import { unwrapResult } from "@reduxjs/toolkit";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useParams, useHistory } from "react-router-dom";

import LoginComponent from "./loginComponent";

import { confirmInvitation, login, parseToken } from "../../redux/state/accountSlice";

const LinkInvitationLogin = () => {

    const user = useSelector(state => state.account.userByParseToken, shallowEqual);

    const dispatch = useDispatch();
    const history = useHistory();
    const { token } = useParams();

    useEffect(() => {
        if (!user.id) {
            dispatch(parseToken(token))
        }
    }, [user, token, dispatch])

    const loginHandler = ({ email, password }) => {
        dispatch(login({ email, password }))
            .then(unwrapResult)
            .then(() => {
                if (!!token) {
                    dispatch(confirmInvitation(token))
                        .then(unwrapResult)
                        .then((response) => {
                            if (response.isSuccessful && !!user.communityId) {
                                history.push(`/communities/community/${user.communityId}`)
                            }
                        })
                        .catch(({ title }) => console.error(title))
                }
                history.push(`/communities/community/${user.communityId}`);
            })
            .catch(({ title }) => console.error(title))
    }

    return <LoginComponent onLogin={loginHandler} signUpUrl={`/sign-up?token=${token}`} />
}

export default LinkInvitationLogin;